export const getCaptchaTheme = theme => {
  if (theme === "satellite-theme") return "dark";

  return "light";
};
